/* Cart writes run only inside the theme cart controller's shared queue. */
(function (scope) {
  'use strict';
  const productId = 8581948703059;
  const en = () => typeof document !== 'undefined' && document.documentElement.lang.startsWith('en');
  const message = (fr, english) => en() ? english : fr;
  const identity = item => JSON.stringify([String(item.variant_id || item.id), Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b)), String(item.selling_plan_allocation?.selling_plan?.id || item.selling_plan || '')]);
  const matches = (cart, token) => cart.items.filter(item => identity(item) === token);
  const one = (cart, token) => { const found = matches(cart, token); if (found.length > 1) throw new Error(message('Plusieurs lignes correspondent. Vérifiez le panier.', 'Several lines match. Please check your cart.')); return found[0]; };
  const uncertain = () => new Error(message('Modification à vérifier dans le panier. Ne répétez pas l’ajout ; actualisez le panier.', 'Please verify this change in your cart. Do not repeat the add; refresh your cart.'));
  const safeError = (error, cart) => Object.assign(error, { cartReconciled: true, cart });

  async function replace({ request, cart, key, variantId, variants }) {
    const old = cart.items.find(item => item.key === key);
    const target = variants.find(variant => String(variant.id) === String(variantId));
    if (!old || Number(old.product_id) !== productId || !target || Number(target.productId) !== productId || !target.available) throw safeError(new Error(message('Cette tête n’est plus disponible pour cette ligne.', 'This head is no longer available for this line.')), cart);
    if (String(old.variant_id || old.id) === String(variantId)) return cart;
    const plan = old.selling_plan_allocation?.selling_plan?.id;
    if (plan ? !target.plans.some(id => String(id) === String(plan)) : target.requiresSellingPlan) throw safeError(new Error(message('Cette tête ne conserve pas votre formule actuelle.', 'This head cannot keep your current purchase plan.')), cart);
    const item = { id: Number(variantId), quantity: old.quantity, properties: old.properties || {} };
    if (plan) item.selling_plan = Number(plan);
    const oldToken = identity(old), targetToken = identity(item);
    const existing = one(cart, targetToken), baseline = existing?.quantity || 0;
    const expected = baseline + old.quantity;
    let added;
    try { await request('cart/add.js', { items: [item] }); }
    catch (error) {
      // An interrupted POST may have succeeded. Read before deciding; never retry it.
      try { added = await request('cart.js'); } catch (_) { throw uncertain(); }
      if ((one(added, targetToken)?.quantity || 0) === baseline && one(added, oldToken)?.quantity === old.quantity) throw safeError(error, added);
    }
    if (!added) { try { added = await request('cart.js'); } catch (_) { throw uncertain(); } }
    const addedLine = one(added, targetToken), oldLine = one(added, oldToken);
    if (addedLine?.quantity !== expected || oldLine?.quantity !== old.quantity) throw uncertain();
    let removed;
    try { removed = await request('cart/change.js', { id: oldLine.key, quantity: 0 }); }
    catch (_) { try { removed = await request('cart.js'); } catch (_) { throw uncertain(); } }
    if (!one(removed, oldToken) && one(removed, targetToken)?.quantity === expected) return removed;

    // Keep the old line when removal failed; undo only the quantity we just added.
    const retained = one(removed, oldToken), next = one(removed, targetToken);
    if (retained?.quantity !== old.quantity || next?.quantity !== expected) throw uncertain();
    let rolledBack;
    try { rolledBack = await request('cart/change.js', { id: next.key, quantity: baseline }); }
    catch (_) { try { rolledBack = await request('cart.js'); } catch (_) { throw uncertain(); } }
    if (one(rolledBack, oldToken)?.quantity !== old.quantity || (one(rolledBack, targetToken)?.quantity || 0) !== baseline) throw uncertain();
    throw safeError(new Error(message('Le changement a échoué. Votre tête initiale et sa quantité sont conservées.', 'The change failed. Your original head and quantity have been kept.')), rolledBack);
  }

  scope.GSBladeVariants = { replace };
  if (typeof module !== 'undefined' && module.exports) module.exports = { replace };
  if (typeof document === 'undefined') return;
  let pending = false;
  const ready = () => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.querySelectorAll('[data-cart-blade-select]').forEach(select => {
      select.disabled = pending || drawer.getAttribute('aria-busy') === 'true' || !scope.GSBladeVariantsReady;
    });
  };
  document.addEventListener('gs:cart-blade-ready', () => { scope.GSBladeVariantsReady = true; ready(); });
  document.addEventListener('change', async event => {
    const select = event.target.closest?.('[data-cart-blade-select]');
    if (!select || select.disabled || pending || select.value === select.dataset.current) return;
    const drawer = select.closest('[data-cart-drawer]');
    if (!drawer || drawer.getAttribute('aria-busy') === 'true') { select.value = select.dataset.current; return; }
    pending = true;
    const original = select.dataset.current;
    let errorMessage = '';
    try {
      const variants = JSON.parse(select.closest('[data-cart-blade-control]').querySelector('[data-cart-blade-data]').textContent);
      const detail = { key: select.dataset.key, variantId: select.value, variants, task: null };
      select.dispatchEvent(new CustomEvent('gs:cart-blade-change', { detail, bubbles: true }));
      if (!detail.task) throw new Error(message('Actualisez le panier pour changer de tête.', 'Refresh your cart to change the head.'));
      ready();
      const result = await detail.task;
      if (result?.changed === false) {
        errorMessage = result.message || message('La tête initiale est conservée.', 'Your original head has been kept.');
        if (select.isConnected) select.value = original;
      } else if (result?.notice) errorMessage = result.notice;
    } catch (error) { errorMessage = error.message; if (select.isConnected) select.value = original; }
    finally {
      pending = false; ready();
      let status = drawer.querySelector('[data-cart-blade-status]');
      if (!status) { status = document.createElement('p'); status.dataset.cartBladeStatus = ''; status.setAttribute('role', 'status'); status.tabIndex = -1; drawer.append(status); }
      status.textContent = errorMessage || message('Tête modifiée. Vérifiez le récapitulatif de votre panier.', 'Head changed. Check your cart summary.');
      if (document.activeElement === document.body || document.activeElement === select) status.focus({ preventScroll: true });
    }
  });
  const drawer = document.querySelector('[data-cart-drawer]');
  if (drawer) new MutationObserver(ready).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-busy'] });
  ready();
})(typeof window !== 'undefined' ? window : globalThis);
